/**
 * defa.collections.accessoriesHolders
 * A Collection of AccessoriesHolder
 * @version 1.2.0
 */
import AccessoriesHolder from './model-accessories-holder';

const AccessoriesHolders = Bb.Collection.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	model : AccessoriesHolder,
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );


export default AccessoriesHolders;